module.exports = __webpack_public_path__ + "img/qual_pt.7082a659.png";